import { AUTH, PAGE_NOT_FOUND } from '../../../constants/routes';

enum Event {
  // Login Page

  LOGIN_MOBILE_NUMBER_SUCCESS = 'Login mobile number success',
  LOGIN_MOBILE_NUMBER_ERROR = 'Login mobile number error',
  LOGIN_WITH_BRANCH_DATA = 'Login with branch data',

  // OTP page

  LOGIN_MOBILE_NUMBER_EDIT_CLICKED = 'Login mobile number edit clicked',
  SUBMIT_OTP_SUCCESS = 'Submit otp success',
  SUBMIT_OTP_ERROR = 'Submit otp error',
  RESEND_OTP_CLICKED = 'Resend otp clicked',
  RESEND_OTP_SUCCESS = 'Resend otp success',

  // Sign up

  CREATE_ACCOUNT_CLICKED = 'Create account clicked',
  CREATE_ACCOUNT_CONTINUE_CLICKED = 'Create account continue clicked',
  DOCUMENT_UPLOAD_CONTINUE_CLICKED = 'Document upload continue clicked',
  DOCUMENT_UPLOAD_SUCCESS = 'Document upload success',
  DOCUMENT_UPLOAD_ERROR = 'Document upload error',
  DOCUMENT_REUPLOAD_SUCCESS = 'Document reupload success',
  DOCUMENT_REUPLOAD_ERROR = 'Document reupload error',
  CREATE_BRANCH_CONTINUE_CLICKED = 'Create branch continue clicked',
  BRANCH_IMAGE_UPLOAD_SUCCESS = 'Branch image upload success',
  BRANCH_IMAGE_UPLOAD_ERROR = 'Branch image upload error',
  UPI_VERIFICATION_SUCCESS = 'Upi verification success',
  UPI_VERIFICATION_ERROR = 'Upi verification error',
  BANK_ACCOUNT_VERIFICATION_SUCCESS = 'Bank account verification success',
  BANK_ACCOUNT_VERIFICATION_ERROR = 'Bank account verification error',
  SETTLEMENT_SELECTION_PAGE_BUTTON_CLICKED = 'Settlement selection page button clicked',
  ONBOARD_SUCCESS = 'Onboard success',
  ONBOARD_ERROR = 'Onboard error',

  // SIDEBAR_TAB_CLICKED = 'Sidebar tab clicked',

  // Branches

  BRANCH_CARD_CLICKED = 'Branch card clicked',
  BRANCH_EDIT_CLICKED = 'Branch edit clicked',
  ADD_NEW_BRANCH_CLICKED = 'Add new branch clicked',
  BRANCH_CREATION_SUCCESS = 'Branch creation success',
  BRANCH_CREATION_ERROR = 'Branch creation error',
  BRANCH_UPDATION_SUCCESS = 'Branch updation success',
  BRANCH_UPDATION_ERROR = 'Branch updation error',
  BRANCH_CREATION_CANCEL_CLICKED = 'Branch creation cancel clicked',
  SETTLEMENT_ACCOUNT_ADD_NEW_CLICKED = 'Settlement account ADD NEW clicked',
  SETTLEMENT_ACCOUNT_UPDATE_CLICKED = 'Settlement account UPDATE clicked',

  // Groups

  ADD_NEW_GROUP_CLICKED = 'Add new group clicked',
  GROUP_IMAGE_UPLOAD_SUCCESS = 'Group image upload success',
  GROUP_IMAGE_UPLOAD_ERROR = 'Group image upload error',
  GROUP_CREATION_SUCCESS = 'Group creation success',
  GROUP_CREATION_ERROR = 'Group creation error',
  GROUP_CREATION_CANCEL_CLICKED = 'Group creation cancel clicked',

  GROUP_CARD_CLICKED = 'Group card clicked',
  GROUP_EDIT_ICON_CLICKED = 'Group edit icon clicked',
  GROUP_INFO_TAB_CHANGED = 'Group Info: tab changed',
  GROUP_DUPLICATE_CLICKED = 'Group duplicate clicked',

  GROUP_EDIT_REVIEW_VIEWED = 'Group edit review viewed',
  MEMBER_DETAIL_UPDATION_VIA_GROUP_EDIT = 'Member detail updation via group edit',
  GROUP_UPDATION_SUCCESS = 'Group updation success',
  GROUP_UPDATION_ERROR = 'Group updation error',
  REPORT_DOWNLOAD_SUCCESS = 'Report download success',
  REPORT_DOWNLOAD_ERROR = 'Report download error',
  MEMBER_DELETE_SUCCESS = 'Member delete success',
  MEMBER_DELETE_ERROR = 'Member delete error',
  MEMBER_UPDATION_SUCCESS = 'Member updation success',
  MEMBER_UPDATION_ERROR = 'Member updation error',
  MEMBER_ADDITION_TO_EXISTING_GROUP_SUCCESS = 'Add member to existing group success',
  MEMBER_ADDITION_TO_EXISTING_GROUP_ERROR = 'Add member to existing group error',

  // Members

  MEMBER_ADDITION_SUCCESS = 'Member addition successful',
  MEMBER_ADDITION_ERROR = 'Member addition failed',
  MEMBER_EDIT_SUCCESS = 'Member edit successful',
  MEMBER_EDIT_ERROR = 'Member edit failed',

  // Team Management

  INVITATION_SEND_SUCCESS = 'Invitation send success',
  INVITATION_SEND_ERROR = 'Invitation send error',
  INVITATION_DELETE_SUCCESS = 'Invitation delete success',
  INVITATION_DELETE_ERROR = 'Invitation delete error',
  USER_DELETE_SUCCESS = 'User delete success',
  USER_DELETE_ERROR = 'User delete error',
  USER_UPDATION_SUCCESS = 'User updation success',
  USER_UPDATION_ERROR = 'User updation error',

  TM_TAB_CHANGED = 'TM: tab changed',
  INVITE_MEMBER_BUTTON_CLICKED = 'Invite Member button clicked',

  // Accept/Reject Invitations

  INVITATION_POPUP_VIEWED = 'Invitation popup viewed',
  INVITATION_ACCEPTED_SUCCESS = 'Invitation accepted success',
  INVITATION_ACCEPTED_ERROR = 'Invitation accepted error',
  INVITATION_DECLINE_SUCCESS = 'Invitation decline success',
  INVITATION_DECLINE_ERROR = 'Invitation decline error',

  // Upgrade to organization

  UPGRADE_TO_ORGANIZATION_POPUP_VIEWED = 'Upgrade to organization popup viewed',
  UPGRADE_TO_ORGANIZATION_CONFIRM_BUTTON_CLICKED = 'Upgrade to organization confirm button clicked',
  UPGRADE_TO_ORGANIZATION_CANCEL_BUTTON_CLICKED = 'Upgrade to organization cancel button clicked',

  // Upgrade Lite

  UPGRADE_LITE_SUCCESS = 'Upgrade lite success',
  UPGRADE_LITE_ERROR = 'Upgrade lite error',
  // Switch account

  SWITCH_ACCOUNT_CLICKED = 'Switch account clicked',
  SWITCH_ACCOUNT_CONTINUE_BUTTON_CLICKED = 'Switch account continue button clicked',
  SWITCH_ACCOUNT_CANCEL_BUTTON_CLICKED = 'Switch account cancel button clicked',

  // Organzation rejected

  CONTACT_SUPPORT_CLICKED = 'Contact support clicked',

  // Organization Selection

  ORGANIZATION_SELECTION_CONTINUE_CLICKED = 'Organization Selection continue clicked',

  // Logout

  LOGOUT_CLICKED = 'Logout clicked',
  LOGOUT_CONFIRM_BUTTON_CLICKED = 'Logout confirm button clicked',
  LOGOUT_CANCEL_BUTTON_CLICKED = 'Logout cancel button clicked',
  LOGOUT_SUCCESS = 'Logout success',
  LOGOUT_ERROR = 'Logout error',

  // Upload

  IMAGE_UPLOAD_ERROR = 'Image upload error',
  FILE_UPLOAD_ERROR = 'File upload error',

  // Help page

  HELP_FEEDBACK_SUCCESS = 'Feedback send success',
  HELP_FEEDBACK_ERROR = 'Feedback send error',

  // Attendance

  ATTENDANCE_TRACKING_ENABLED = 'Attendance tracking enabled',
  ATTENDANCE_DAYS_CLICKED = 'Attendance days clicked',
  ATTENDANCE_SMS_ALERT_CLICKED = 'Attendance SMS alert clicked',
  ATTENDANCE_SMS_ALERT_CONFIRM_CLICKED = 'Attendance SMS alert confirm button clicked',
  ATTENDANCE_EDIT_BUTTON_CLICKED = 'Attendance edit button clicked',
  ATTENDANCE_SUBMIT_BUTTON_CLICKED = 'Attendance submit button clicked',
  ATTENDANCE_STATUS_CHANGE_BUTTON_CLICKED = 'Attendance status change button clicked',
  ATTENDANCE_SUBMIT_CONFIRM_MODAL_BUTTON_CLICKED = 'Attendance submit confirm modal button clicked',
  ATTENDANCE_REPORT_DOWNLOAD_BUTTON_CLICKED = 'Attendance report download button clicked',
  ATTENDANCE_ENABLE_BUTTON_CLICKED = 'Attendance enable button clicked while attendance is disabled',
  ATTENDANCE_MARK_HOLIDAY_CHECKBOX_CLICKED = 'Mark holiday checkbox clicked',
  ATTENDANCE_MARK_HOLIDAY_MODAL_CONFIRM_CLICKED = 'Attendance mark holiday modal confirm clicked',
  ATTENDANCE_UNMARK_HOLIDAY_BUTTON_CLICKED = 'Unmark holiday button clicked',
  ATTENDANCE_UNMARK_HOLIDAY_MODAL_CONFIRM_CLICKED = 'Unmark holiday modal confirm clicked',
  ATTENDANCE_BULK_STATUS_ABSENT_CLICKED = 'Attendance bulk status change absent button clicked',
  ATTENDANCE_BULK_STATUS_EXEMPT_CLICKED = 'Attendance bulk status change exempt button clicked',
  ATTENDANCE_BULK_STATUS_PRESENT_CLICKED = 'Attendance bulk status change present button clicked',

  // Bank Admin

  BANK_ADMIN_TAB_CHANGED = 'Bank admin tab changed',

  // Transaction Page

  TRANSACTION_TAB_CHANGED = 'Transaction page: tab changed',
  TRANSACTION_DETAILS_CLICKED = 'Transaction details row clicked',
  TRANSACTION_PAYMENT_DETAILS_DOWNLOAD_BUTTON_CLICKED = 'Transaction payment details download button clicked',
  TRANSACTION_MARK_AS_PAID_CLICKED = 'Transaction mark as paid button clicked',
  TRANSACTION_DISABLED_BUTTON_CLICKED = 'Transaction disabled button clicked',
  TRANSACTION_DISABLE_MODAL_CONFIRM_CLICKED = 'Transaction disable modal confirm clicked',
  TRANSACTION_SEND_REMINDER_BUTTON_CLICKED = 'Transaction send reminder button clicked',
  TRANSACTION_SEND_REMINDER_MODAL_CONFIRM_CLICKED = 'Transaction send reminder modal confirm clicked',
  TRANSACTION_MARK_AS_PAID_MODAL_CONFIRM_CLICKED = 'Transaction mark as paid modal confirm clicked',
  TRANSACTION_PAYMENT_LINK_COPIED = 'Transaction payment link copied',
  TRANSACTION_DETAILS_SELECTED_BRANCH_CHANGE = 'Transaction details selected branch change',
  TRANSACTION_ENABLE_PARTIAL_PAYMENT_CONFIRM_CLICKED = 'Transaction enable partial payment confirm clicked',
  TRANSACTION_ENABLE_PARTIAL_PAYMENT_CLICKED = 'Transaction enable partial payment button clicked',
  TRANSACTION_CLOSE_PAYMENT_CLICKED = 'Transaction close payment button clicked',
  TRANSACTION_CLOSE_PAYMENT_MODAL_CONFIRM_CLICKED = 'Transaction close payment modal confirm clicked',
  TRANSACTION_UPDATE_DUE_CLICKED = 'Transaction update due action button clicked',
  TRANSACTION_UPDATE_DUE_MODAL_CONFIRM_CLICKED = 'Transaction update due modal confirm clicked',
  TRANSACTION_APPLY_DISCOUNT_CONFIRM_CLICKED = 'Transaction apply discount confirm clicked',

  // Dashboard Page

  DASHBOARD_HOME_PAGE_VIEWED = 'Dashboard home page viewed',
  ORG_DASHBOARD_HOME_PAGE_VIEWED = 'Org dashboard home page viewed',
  DASHBOARD_SELECTED_DATERANGE = 'Dashboard selected date range',
  DASHBOARD_SELECTED_BRANCH = 'Dashboard selected branch',
  DASHBOARD_SELECTED_BRANCH_FOR_BRANCH_REVENUE = 'Dashboard selected branches for branch revenue graph',

  // Reports Page

  DOWNLOAD_GST_REPORT_CLICKED = 'Download GST report clicked',
  DOWNLOAD_GST_REPORT_ERROR = 'Download GST report error',
  DOWNLOAD_SETTLEMENT_REPORT_CLICKED = 'Download Settlement report clicked',
  DOWNLOAD_SETTLEMENT_REPORT_ERROR = 'Download Settlement report error',
  DOWNLOAD_CUSTOM_REPORT_CLICKED = 'Download Custom report clicked',
  DOWNLOAD_CUSTOM_REPORT_ERROR = 'Download Custom report error',
  DOWNLOAD_CHARGES_REPORT_CLICKED = 'Download Charges report clicked',
  DOWNLOAD_CHARGES_REPORT_ERROR = 'Download Charges report error',
  DOWNLOAD_MEMBERS_EXPORT_CLICKED = 'Download Members Export clicked',
  DOWNLOAD_MEMBERS_EXPORT_ERROR = 'Download Members Export error',
  DOWNLOAD_REPORT_SUCCESS = 'Download Report Success',
  DOWNLOAD_REPORT_FAILED = 'Download Report Failed',

  // Fee Config

  ADD_BRANCH_ACCOUNT_IN_BRANCH_CREATE_OR_EDIT = 'Add Bank Account in Branch create or edit',
  ACCOUNT_LINKED_WITH_PAN_ADDED = 'Account linked with PAN added',
  ERROR_IN_ADDING_ACCOUNT_LINKED_WITH_PAN = 'Error in adding account linked with PAN',
  ACCOUNT_LINKED_WITH_NEW_PAN_ADDED = 'Account linked with new PAN added',
  ERROR_IN_ADDING_NEW_PAN_FOR_BANK_ACCOUNT = 'Error in adding new pan for bank account',
  ERROR_IN_ADDING_ACCOUNT_LINKED_WITH_NEW_PAN = 'Error in adding account linked with new PAN',
  CONFIRMATION_OF_NEW_PAN_LINKED_WITH_ORGANIZATION = 'Confirmation of new PAN linked with organisation',
  FEE_CATEGORIES_ENABLED_OR_DISABLED = 'Fee categories enabled or disabled',
  BRANCH_WITH_FEE_CATEGORY_CREATED_SUCCESSFULLY = 'Branch with fee category created successfully',
  BRANCH_WITH_FEE_CATEGORY_UPDATED_SUCCESSFULLY = 'Branch with fee category updated successfully',
  ERROR_IN_CREATING_BRANCH_WITH_FEE_CATEGORY = 'Error in creating branch with fee category',
  ERROR_IN_UPDATING_BRANCH_WITH_FEE_CATEGORY = 'Error in updating branch with fee category',
  FEE_CATEGORY_ENABLED_OR_DISABLED_IN_ADD_OR_EDIT_GROUP = 'Fee category enabled or disabled in add or edit group',
  FEE_AMOUNTS_IN_FEE_CATEGORY_OF_GROUP_IS_EDITED = 'Fee amounts in fee category of group is edited',
  GROUP_WITH_FEE_CATEGORY_CREATED = 'Group with fee category created',
  GROUP_WITH_FEE_CATEGORY_EDITED = 'Group with fee category edited',
  ERROR_IN_EDITING_GROUP_WITH_FEE_CATEGORY = 'Error in editing group with fee category',

  // Rapid Onboard

  // SAME_NAME_ON_RECEIPT = 'Same name on receipt',
  DISPLAY_NAME_ON_RECEIPT = 'Display name on receipt',
  ADD_KYC_INFO_CLICKED = 'Add KYC info clicked',
  KYC_DETAILS_VERIFIED = 'KYC Details verified',
  KYC_VERIFICATION_ERROR = 'KYC Verification error',
  CONTINUE_IN_COMPLETE_KYC_POPUP_CLICKED = 'Continue in complete KYC pop up clicked',
  CANCEL_IN_COMPLETE_KYC_POPUP_CLICKED = 'Cancel in complete KYC pop up clicked',

  // Quick collect
  ERROR_IN_CREATING_QUICK_COLLECT_LINK = 'Error in creating quick collect link',
  QUICK_COLLECT_SUCCESS = 'Quick collect link creation success',
  QUICK_COLLECT_INVALID_CSV = 'Quick collect invalid csv',

  // Group Transaction Page

  GROUP_TRANSACTION_TAB_CHANGED = 'Group Transaction: tab changed',
  GROUP_TRANSACTION_DETAILS_CLICKED = 'Group transaction details row clicked',
  GROUP_TRANSACTION_PAYMENT_DETAILS_DOWNLOAD_BUTTON_CLICKED = 'Group Transaction payment details download button clicked',
  GROUP_TRANSACTION_MARK_AS_PAID_CLICKED = 'Group Transaction mark as paid button clicked',
  GROUP_TRANSACTION_DISABLED_BUTTON_CLICKED = 'Group Transaction disabled button clicked',
  GROUP_TRANSACTION_DISABLE_MODAL_CONFIRM_CLICKED = 'Group Transaction disable modal confirm clicked',
  GROUP_TRANSACTION_SEND_REMINDER_BUTTON_CLICKED = 'Group Transaction send reminder button clicked',
  GROUP_TRANSACTION_SEND_REMINDER_MODAL_CONFIRM_CLICKED = 'Group Transaction send reminder modal confirm clicked',
  GROUP_TRANSACTION_PAYMENT_LINK_COPIED = 'Group Transaction payment link copied',
  GROUP_TRANSACTION_ENABLE_PARTIAL_PAYMENT_CONFIRM_CLICKED = 'Group Transaction enable partial payment confirm clicked',
  GROUP_TRANSACTION_ENABLE_PARTIAL_PAYMENT_CLICKED = 'Group Transaction enable partial payment button clicked',
  GROUP_TRANSACTION_CLOSE_PAYMENT_CLICKED = 'Group Transaction close payment button clicked',
  GROUP_TRANSACTION_CLOSE_PAYMENT_MODAL_CONFIRM_CLICKED = 'Group Transaction close payment modal confirm clicked',
  GROUP_TRANSACTION_UPDATE_DUE_CLICKED = 'Group Transaction update due action button clicked',

  // Events
  EVENT_TAB_CHANGE = 'Event tab change',
  CREATE_EVENT_CLICKED = 'Create event clicked',
  EVENT_CREATION_SUCCESS = 'Event creation success',
  EVENT_CREATION_ERROR = 'Event creation error',
  ADDITIONAL_DOCUMENT_UPLOADED = 'Additional document uploaded',
  NEW_TICKET_ADDED = 'New ticket added',
  EDIT_TICKET_SAVE = 'Edit ticket saved',
  ADD_QUESTION_SAVE = 'Add question save',
  COPY_LINK_IN_PUBLISH_SCREEN = 'Copy link in publish screen',
  DOWNLOAD_QR_CODE_IN_PUSLISH_SCREEN = 'Download QR code in publish screen',
  COPY_LINK_IN_EVENT_DETAILS_SCREEN = 'Copy link in event details screen',
  DOWNLOAD_QR_CODE_IN_EVENT_DETAILS_SCREEN = 'Download QR code in event details screen',
  EVENT_EDIT_CLICKED_IN_EVENT_DETAILS_SCREEN = 'Event edit clicked in event details screen',
  EVENT_DUPLICATE_CLICKED_IN_EVENT_DETAILS_SCREEN = 'Event duplicate clicked in event details screen',
  ATTENDEE_EXPORT_CSV_CLICKED = 'Attendee export CSV clicked',
  COPY_LINK_IN_EVENTS_CARD = 'Copy link in events card',
  DOWNLOAD_QR_CODE_IN_EVENTS_CARD = 'Download QR code in events card',
  EDIT_EVENT_IN_EVENTS_CARD = 'Edit event in events card',
  CLOSE_EVENT_IN_EVENTS_CARD = 'Close event in events card',
  DELETE_EVENT_IN_EVENTS_CARD = 'Delete event in events card',
  EVENT_LOGO_UPLOAD_CLICKED = 'Event Logo Upload Clicked',
  EVENT_LOGO_DRAG_AND_DROP = 'Event Logo Drag and Drop',

  // Settings Page
  SETTINGS_TAB_SELECTED = 'Settings Tab Selected',
  CREATE_API_CLICKED = 'Create API Click',
  CREATE_API_KEY_SUCCESS = 'Create API Key Succes',
  CREATE_API_KEY_FAILED = 'Create API Key Failed',
  EDIT_API_NAME_SUCCESS = 'Edit API Name Success',
  EDIT_API_NAME_FAILED = 'Edit API Name Failed',
  COPY_API_KEY = 'Copy API Key',
  CREATE_WEBHOOK_CLICKED = 'Create Webhook Clicked',
  CREATE_WEBHOOK_SUCCESS = 'Create Webhook Success',
  CREATE_WEBHOOK_FAILED = 'Create Webhook Failed',
  EDIT_WEBHOOK_SUCCESS = 'Edit Webhook Success',
  EDIT_WEBHOOK_FAILED = 'Edit Webhook Failed',
  EDIT_WEBHOOK_CLICKED = 'Edit Webhook Clicked',
  DELETE_WEBHOOK_CLICKED = 'Delete Webhook Clicked',
  DELETE_WEBHOOK_SUCCESS = 'Delete Webhook Success',
  DELETE_WEBHOOK_FAILED = 'Delete Webhook Failed',

  // Expense Dashboard
  EXPENSE_DASHBOARD_VIEWED = 'Expense Dashboard Viewed',
  EXPENSE_LIST_VIEWED = 'Expense List Viewed',
  EXPENSE_DASHBOARD_DATE_RANGE_FILTER_APPLIED = 'Expense Dashoard Date Filter Applied',
  EXPENSE_DASHBOARD_BRANCH_FILTER_APPLIED = 'Expense Dashoard Branch Filter Applied',
  EXPENSE_DASHBOARD_BRANCH_SELECTED = 'Expense Dashoard Branch Selected',
  EXPENSE_DASHBOARD_DATA_LOADED = 'Expense Dashoard Data Loaded',

  // Expense List
  EXPENSE_LIST_FILTER_APPLIED = 'Expense List Filter Applied',
  EXPENSE_LIST_TAB_CHANGED = 'Expense List Tab Changed',
  EXPENSE_APPROVED_TAB_VIEWED = 'Approved Tab Viewed',
  EXPENSE_PENDING_TAB_VIEWED = 'Pending Tab Viewed',
  EXPENSE_REJECTED_TAB_VIEWED = 'Rejected Tab Viewed',
  EXPENSE_ADD_EXPENSE_CLICKED = 'Add Expense Clicked',
  NEW_EXPENSE_SUCCESSFULLY_SUBMITTED = 'New Expense Successfully Submitted',
  EXPENSE_DETAILS_VIEWED = 'Expense Details Viewed',
  EXPENSE_DELETE_CLICKED = 'Expense Deleted',
  EXPENSE_APPROVED_CLICKED = 'Expense Approved',
  EXPENSE_REJECTED_CLICKED = 'Expense Rejected',

  // Member Transaction
  MEMBER_TRANSACTION_TAB_CHANGED = 'Member Transaction: tab changed',
  MEMBER_TRANSACTION_PAYMENT_LINK_COPIED = 'Member Transaction payment link copied',
  MEMBER_TRANSACTION_DETAILS_CLICKED = 'Member Transaction details clicked',
  MEMBER_TRANSACTION_DISABLED_BUTTON_CLICKED = 'Member Transaction disabled button clicked',
  MEMBER_TRANSACTION_SEND_REMINDER_BUTTON_CLICKED = 'Member Transaction send reminder button clicked',
  MEMBER_TRANSACTION_ENABLE_PARTIAL_PAYMENT_CLICKED = 'Member Transaction enable partial payment button clicked',
  MEMBER_TRANSACTION_CLOSE_PAYMENT_CLICKED = 'Member Transaction close payment button clicked',
  MEMBER_TRANSACTION_SEND_REMINDER_MODAL_CONFIRM_CLICKED = 'Member Transaction send reminder modal confirm clicked',
  MEMBER_TRANSACTION_ENABLE_PARTIAL_PAYMENT_CONFIRM_CLICKED = 'Member Transaction enable partial payment confirm clicked',
  MEMBER_TRANSACTION_DISABLE_MODAL_CONFIRM_CLICKED = 'Member Transaction disable modal confirm clicked',
  MEMBER_TRANSACTION_MARK_AS_PAID_CLICKED = 'Member Transaction mark as paid button clicked',
  MEMBER_TRANSACTION_PAYMENT_DETAILS_DOWNLOAD_BUTTON_CLICKED = 'Member Transaction payment details download button clicked',
  MEMBER_TRANSACTION_UPDATE_DUE_CLICKED = 'Member Transaction update due action button clicked',

  // Group Management
  COPY_LINK_IN_COFEE_INTRO_MESSAGE_MODAL = 'Copy link in cofee intro message modal',
  YES_I_VE_SHARED_CONSENT_CLICKED = "Yes I've shared consent clicked",
  I_LL_SHARE_LATER_CONSENT_CLICKED = "I'll share later consent clicked",
  SHARE_COFEE_INTRO_MESSAGE_BUTTON_CLICKED = 'Share cofee intro message button clicked',

  // Lead Management
  LEAD_CREATED = 'Lead created',
  LEAD_CSV_PROCESSED = 'Lead CSV processed',
  LEAD_ASSIGNED = 'Lead assigned',
  LEAD_DETAILS_VIEWED = 'Lead details page viewed',
  LEAD_UPDATED = 'Lead updated',
  LEAD_NOTES_VIEWED = 'Lead notes viewed',
  LEAD_NOTE_CREATED = 'Lead note created',
  LEAD_NOTE_UPDATED = 'Lead note updated',
  LEAD_NOTE_DELETED = 'Lead note deleted',
  LEAD_ATTACHMENTS_VIEWED = 'Lead attachments viewed',
  LEAD_ATTACHMENT_UPLOADED = 'Lead attachment uploaded',
  LEAD_ATTACHMENT_DELETED = 'Lead attachment deleted',
  LEAD_TIMELINE_VIEWED = 'Lead timeline viewed',
  LEAD_ADD_TO_GROUP_CLICKED = 'Lead add to group clicked',
  LEAD_ADDED_TO_GROUPS = 'Lead added to groups',
  LEAD_PAYMENT_LINK_SENT = 'Lead payment link sent',
  LEAD_MANAGEMENT_DASHBOARD_VIEWED = 'Lead management dashboard viewed',
  LEAD_REPORT_GENERATED = 'Lead Report generated',
  LEADS_LIST_VIEWED = 'Leads list viewed',
  LEAD_LIST_FILTERED = 'Lead list filtered',
  LEAD_LIST_SEARCHED = 'Lead list searched',
  LEAD_STATUS_UPDATE = 'Lead status update',
  LEAD_STATUS_ADDITION = 'Lead status addition',
  LEAD_STATUS_DELETION = 'Lead status deletion',
  // Lead Activity
  LEAD_ACTIVITIES_CLICKED = 'Lead activities clicked',
  LEAD_ACTIVITIES_TASK_ADDED = 'Lead activities task added',
  LEAD_ACTIVITIES_TASK_UPDATED = 'Lead activities task updated',
  LEAD_ACTIVITIES_TASK_DELETED = 'Lead activities task deleted',
  LEAD_ACTIVITIES_MEETINGS_ADDED = 'Lead activities meetings added',
  LEAD_ACTIVITIES_MEETINGS_UPDATED = 'Lead activities meetings updated',
  LEAD_ACTIVITIES_MEETINGS_DELETED = 'Lead activities meetings deleted',
  LEAD_ACTIVITIES_CALL_INFO_ADDED = 'Lead activities call info added',
  LEAD_ACTIVITIES_CALL_INFO_UPDATED = 'Lead activities call info updated',
  LEAD_ACTIVITIES_CALL_INFO_DELETED = 'Lead activities call info deleted',

  // Dynamic components (banner / popup)
  DYNAMIC_NOTIFICATION_VIEWED = 'Dynamic_notification_ viewed',
  DYNAMIC_NOTIFICATION_CTA_CLICKED = 'Dynamic_notification_ action_clicked',

  // Performance
  SLOW_API_RESPONSE = 'Slow API Response'
}

enum MixpanelEventV2 {
  //  Login and OTP
  LOGIN_SCREEN_VIEWED = 'Login Screen Viewed',
  MOBILE_NUMBER_ENTERED_AND_CONTINUED = 'Mobile number entered and continued',
  OTP_SCREEN_VIEWED = 'OTP Screen Viewed',
  MOBILE_NUMBER_EDIT_CLICKED = 'Mobile Number Edit Clicked',
  OTP_RESEND_CLICKED = 'OTP Resend Clicked',
  OTP_SUBMITTED = 'OTP Submitted',

  //  Profile Name & Category
  PROFILE_NAME_ENTRY_SCREEN_VIEWED = 'Profile Name Entry Screen Viewed',
  PROFILE_NAME_SUBMITTED = 'Profile Name Submitted',
  BUSINESS_NAME_SCREEN_VIEWED = 'Business Name Screen Viewed',
  BUSINESS_NAME_SUBMITTED = 'Business Name Submitted',
  BUSINESS_NAME_SAMPLE_VIEWED = 'Business Name Sample Viewed',
  BUSINESS_NAME_SAMPLE_DISMISSED = 'Business Name Sample Dismissed',
  CATEGORY_SELECTION_SCREEN_VIEWED = 'Category Selection Screen Viewed',
  CATEGORY_SEARCHED = 'Category Searched',
  CATEGORY_SELECTED = 'Category Selected',
  CATEGORY_SELECTION_SUBMITTED = 'Category Selection Submitted',

  //  KYC — Details, Documents, Bank
  KYC_DETAILS_PAGE_VIEWED = 'KYC Details Page Viewed',
  KYC_DETAILS_ENTERED_AND_CONTINUED = 'KYC Details Entered and Continued',
  KYC_DOCUMENTS_PAGE_VIEWED = 'KYC Documents Page Viewed',
  KYC_DOCUMENTS_UPLOADED_AND_CONTINUED = 'KYC Documents Uploaded and Continued',
  PAN_GST_FILE_ATTACHED = 'PAN/GST File Attached',
  PAN_GST_FILE_DELETED = 'PAN/GST File Deleted',
  KYC_BANK_VERIFICATION_ATTEMPTED = 'KYC Bank Verification Attempted',
  KYC_BANK_DETAILS_EDITED = 'KYC Bank Details Edited',
  KYC_BANK_DETAILS_PAGE_VIEWED = 'KYC Bank Details Page Viewed',
  KYC_SUBMITTED = 'KYC Submitted',
  BUSINESS_LICENSE_ATTACHED = 'Business License Attached',
  BUSINESS_LICENSE_DELETED = 'Business License Deleted',

  // Landing & Verification States
  LANDING_PAGE_AFTER_LOGIN_VIEWED = 'Landing Page After Login Viewed',
  SELF_DECLARATION_FORM_OPENED = 'Self Declaration Form Opened',
  SELF_DECLARATION_FORM_SUBMITTED = 'Self Declaration Form Submitted',

  // KYC Banner
  KYC_MODAL_OPENED = 'KYC Modal/Page Opened',
  KYC_MODAL_DISCARDED = 'KYC Modal/Page Discarded',

  // Rejection & Resubmission
  RESUBMIT_KYC_CLICKED = 'Resubmit KYC Clicked',
  RESUBMIT_KYC_CANCELLED_DISCARDED = 'Resubmit KYC Cancelled/Discarded',

  // Upgrade to Organization
  UPGRADE_TO_ORG_CLICKED = 'Upgrade To Org Clicked',
  UPGRADE_TO_ORG_MODAL_VIEWED = 'Upgrade To Org Modal Viewed',
  UPGRADE_TO_ORG_CONFIRMED = 'Upgrade To Org Confirmed',
  UPGRADE_TO_ORG_CANCELLED = 'Upgrade To Org Cancelled',

  // Branch
  ACCOUNT_APPROVED_MODAL_VIEWED = 'Account Approved Modal Viewed',
  ACCOUNT_APPROVED_MODAL_SKIPPED = 'Account Approved Modal Skipped',
  BRANCH_SETTINGS_CLICKED = 'Branch Settings Clicked',
  BRANCH_DASHBOARD_CLICKED = 'Branch Dashboard Clicked',
  BRANCH_DASHBOARD_DATE_RANGE_CHANGED = 'Branch Dashboard Date Range Changed',
  BRANCH_DASHBOARD_FILTER_CHANGED = 'Branch Dashboard Filter Changed',
  BRANCH_SWITCH_SELECTED = 'Branch Switch Selected',
  BRANCH_ID_COPIED = 'Branch ID Copied',
  BRANCH_SWITCHED = 'Branch Switched',
  CREATE_BRANCH_CLICKED = 'Create Branch Clicked',
  CREATE_BRANCH_MODAL_VIEWED = 'Create Branch Modal Viewed',
  BRANCH_CREATED = 'Branch Created',
  CREATE_BRANCH_MODAL_CANCELLED = 'Create Branch Modal Cancelled',
  BRANCH_SETTINGS_VIEWED = 'Branch Settings Viewed',
  BRANCH_LOGO_UPDATED = 'Branch Logo Updated',
  BRANCH_SETTINGS_SAVED = 'Branch Settings Saved',
  MANAGE_BANK_ACCOUNT_CLICKED = 'Manage Bank Account Clicked',
  MANAGE_BANK_ACCOUNT_VIEWED = 'Manage Bank Account Viewed',
  BANK_ACCOUNT_SEARCHED = 'Bank Accounts Searched',
  BANK_ACCOUNT_FILTERED = 'Bank Accounts Filtered',
  BANK_ACCOUNT_EDIT_DETAILS_CLICKED = 'Bank Account Edit/Details Clicked',
  BANK_ACCOUNT_EDIT_DETAILS_MODAL_VIEWED = 'Bank Account Edit/Details Modal Viewed',
  BANK_ACCOUNT_EDIT_DETAILS_SAVED = 'Bank Account Edit/Details Saved',
  BANK_ACCOUNT_EDIT_DETAILS_MODAL_CANCELLED = 'Bank Account Edit/Details Modal Cancelled',
  BANK_ACCOUNT_SET_AS_DEFAULT_CLICKED = 'Bank Account Set As Default Clicked',
  ADD_BANK_ACCOUNT_CLICKED = 'Add Bank Account Clicked',
  ADD_BANK_ACCOUNT_MODAL_VIEWED = 'Add Bank Account Modal Viewed',
  PAN_DOCUMENT_UPLOADED = 'PAN Document Uploaded',
  SUPPORTING_DOCUMENT_UPLOADED = 'Supporting Document Uploaded',
  BANK_ACCOUNT_ADDED = 'Bank Account Added',
  ADD_BANK_ACCOUNT_CANCELLED = 'Add Bank Account Cancelled',

  // Groups
  GROUPS_LIST_VIEWED = 'Groups list viewed',
  GROUP_CARD_CLICKED = 'Group Card Clicked',
  GROUPS_SEARCHED = 'Groups searched',
  GROUPS_FILTERED = 'Groups filtered',
  CREATE_GROUP_CLICKED = 'Create Group Clicked',
  CREATE_GROUP_MODAL_VIEWED = 'Create Group Modal Viewed',
  CREATE_GROUP_MODAL_PROCEED_CLICKED = 'Create Group Modal Proceed Clicked',
  CREATE_GROUP_MODAL_CANCELLED = 'Create Group Modal Cancelled',
  CREATE_GROUP_CANCELLED = 'Create Group Cancelled',
  GROUP_MEMBER_ADD_CLICKED = 'Group Member Add Clicked',
  GROUP_MEMBER_ADD_SCREEN_VIEWED = 'Group Member Add Screen Viewed',
  GROUP_MEMBER_ADD_FROM_LIST_CLICKED = 'Group Member Add From List Clicked',
  GROUP_MEMBER_ADD_IMPORT_FILE_CLICKED = 'Group Member Add Import File Clicked',
  GROUP_MEMBER_ADD_MANUALLY_CLICKED = 'Group Member Add Manually Clicked',
  GROUP_MEMBER_ADD_MANUALLY_FORM_OPENED = 'Group Member Add Manually Form Opened',
  GROUP_MEMBER_MANUALLY_SAVED_IN_ADDITION_FLOW = 'Group Member Manually Saved In Addition Flow',
  GROUP_MEMBER_ADD_ANOTHER_CLICKED = 'Group Member Add Another Clicked',
  GROUP_MEMBER_ADDED = 'Group Member Added',
  GROUP_MEMBER_IMPORT_TEMPLATE_DOWNLOADED = 'Group Member Import Template Downloaded',
  GROUP_MEMBER_IMPORT_FILE_UPLOADED = 'Group Member Import File Uploaded',
  GROUP_MEMBER_IMPORT_FILE_PREVIEW_VIEWED = 'Group Member Import File Preview Viewed',
  GROUP_MEMBER_IMPORT_FILE_PROCEEDED = 'Group Member Import File Proceeded',
  GROUP_MEMBER_IMPORT_FILE_CANCELLED = 'Group Member Import File Cancelled',
  GROUP_CREATED = 'Group Created',
  MEMBER_LIST_IN_ADD_MEMBER_FLOW_SEARCHED = 'Member List In Add Member Flow Searched',
  GROUP_DETAILS_VIEWED = 'Group Details Viewed',
  GROUP_DETAILS_TAB_SWITCHED = 'Group Details Tab Switched',
  GROUP_INSIGHTS_REPORT_DOWNLOAD_CLICKED = 'Group Insights Report Download Clicked',
  GROUP_INSIGHTS_DOWNLOADED = 'Group Insights Downloaded',
  GROUP_EDIT_CLICKED = 'Group Edit Clicked',
  GROUP_EDIT_SAVED = 'Group Edit Saved',
  GROUP_EDIT_REVIEW_MODAL_VIEWED = 'Group Edit Review Modal Viewed',
  GROUP_DUPLICATE_CLICKED = 'Group Duplicate Clicked',
  GROUP_DEACTIVATE_CLICKED = 'Group Deactivate Clicked',
  GROUP_DEACTIVATED = 'Group Deactivated',
  GROUP_DEACTIVATE_CANCELLED = 'Group Deactivate Cancelled',
  GROUP_ACTIVATE_CLICKED = 'Group Activate Clicked',
  GROUP_ACTIVATED = 'Group Activated',
  GROUP_ACTIVATE_CANCELLED = 'Group Activate Cancelled',
  COFEE_PAY_SHARE_PROMPT_VIEWED = 'CoFeePay Share Prompt Viewed',
  SHARE_PROMPT_SHARED = 'Share Prompt Shared',
  SHARE_PROMPT_SKIPPED = 'Share Prompt Skipped',

  // Group Members
  GROUP_MEMBER_LIST_VIEWED = 'Group Member List Viewed',
  GROUP_MEMBER_DETAILS_VIEWED = 'Group Member Details Viewed',
  GROUP_MEMBER_DETAILS_TAB_SWITCHED = 'Group Member Details Tab Switched',
  GROUP_MEMBER_INSTALLMENT_DETAILS_VIEWED = 'Group Member Installment Details Viewed',
  GROUP_MEMBER_FEE_SUMMARY_EXPANDED = 'Group Member Fee Summary Expanded',
  GROUP_MEMBERS_FILTERED = 'Group Members Filtered',
  GROUP_MEMBERS_FILTER_CANCELLED = 'Group Members Filter Cancelled',
  GROUP_MEMBER_SEARCHED = 'Group Member Searched',
  GROUP_MEMBER_EDIT_CLICKED = 'Group Member Edit Clicked',
  GROUP_MEMBER_EDIT_MODAL_VIEWED = 'Group Member Edit Modal Viewed',
  GROUP_MEMBER_EDIT_SAVED = 'Group Member Edit Saved',
  GROUP_MEMBER_EDIT_CANCELLED = 'Group Member Edit Cancelled',
  GROUP_MEMBER_PARTIAL_PAYMENT_ENABLED = 'Group Member Partial Payment Enabled',
  GROUP_MEMBER_PARTIAL_PAYMENT_CANCELLED = 'Group Member Partial Payment Cancelled',
  GROUP_MEMBER_MARKED_AS_PAID = 'Group Member Marked As Paid',
  GROUP_MEMBER_MARK_AS_PAID_CANCELLED = 'Group Member Mark As Paid Cancelled',
  GROUP_MEMBER_DELETE_CLICKED = 'Group Member Delete Clicked',
  GROUP_MEMBER_DELETED = 'Group Member Deleted',
  GROUP_MEMBER_DELETE_CANCELLED = 'Group Member Delete Cancelled',
  GROUP_MEMBER_ACTIVATE_CLICKED = 'Group Member Activate Clicked',
  GROUP_MEMBER_ACTIVATED = 'Group Member Activated',
  GROUP_MEMBER_ACTIVATE_CANCELLED = 'Group Member Activate Cancelled',
  GROUP_MEMBER_DEACTIVATE_CLICKED = 'Group Member Deactivate Clicked',
  GROUP_MEMBER_DEACTIVATED = 'Group Member Deactivated',
  GROUP_MEMBER_DEACTIVATE_CANCELLED = 'Group Member Deactivate Cancelled',
  GROUP_MONTHLY_INSIGHTS_MODAL_VIEWED = 'Group Monthly Insights Modal Viewed',
  GROUP_MONTHLY_INSIGHTS_MODAL_CLOSED = 'Group Monthly Insights Modal Closed',

  // Group Transactions
  GROUP_TRANSACTIONS_VIEWED = 'Group Transactions Viewed',
  GROUP_TRANSACTIONS_TAB_SWITCHED = 'Group Transactions Tab Switched',
  GROUP_TRANSACTIONS_SEARCHED = 'Group Transactions Searched',
  GROUP_TRANSACTIONS_FILTERED = 'Group Transactions Filtered',
  GROUP_TRANSACTIONS_BULK_DISABLE_CLICKED = 'Group Transactions Bulk Disable Clicked',
  GROUP_TRANSACTION_MENU_CLICKED = 'Group Transaction Menu Clicked',
  GROUP_TRANSACTION_MARK_AS_PAID_CLICKED = 'Group Transaction Mark As Paid Clicked',
  GROUP_TRANSACTION_MARK_AS_PAID_MODAL_VIEWED = 'Group Transaction Mark As Paid Modal Viewed',
  GROUP_TRANSACTION_MARK_AS_PAID_PROCEEDED = 'Group Transaction Mark As Paid Proceeded',
  GROUP_TRANSACTION_MARK_AS_PAID_CANCELLED = 'Group Transaction Mark As Paid Cancelled',
  GROUP_TRANSACTION_MARK_AS_PAID_PROCEED_CONFIRMED = 'Group Transaction Mark As Paid Proceed Confirmed',
  GROUP_TRANSACTION_MARK_AS_PAID_PROCEED_CANCELLED = 'Group Transaction Mark As Paid Proceed Cancelled',
  GROUP_TRANSACTION_SEND_REMINDER_CLICKED = 'Group Transaction Send Reminder Clicked',
  GROUP_TRANSACTION_SEND_REMINDER_CONFIRMED = 'Group Transaction Send Reminder Confirmed',
  GROUP_TRANSACTIONS_SEND_REMINDER_ALL_CLICKED = 'Group Transactions Send Reminder All Clicked',
  GROUP_TRANSACTIONS_SEND_REMINDER_ALL_CONFIRMED = 'Group Transactions Send Reminder All Confirmed',
  GROUP_TRANSACTION_ENABLE_PARTIAL_PAYMENT_CLICKED = 'Group Transaction Enable Partial Payment Clicked',
  GROUP_TRANSACTION_ENABLE_PARTIAL_PAYMENT_CONFIRMED = 'Group Transaction Enable Partial Payment Confirmed',
  GROUP_TRANSACTION_PAYMENT_LINK_COPIED = 'Group Transaction Payment Link Copied',
  GROUP_TRANSACTION_DISABLE_CLICKED = 'Group Transaction Disable Clicked',
  GROUP_TRANSACTION_DISABLE_CONFIRMED = 'Group Transaction Disable Confirmed',
  GROUP_TRANSACTION_PAYMENT_DETAILS_VIEWED = 'Group Transaction Payment Details Viewed',
  GROUP_TRANSACTION_FEE_SUMMARY_EXPANDED = 'Group Transaction Fee Summary Expanded',
  GROUP_TRANSACTION_QR_CODE_VIEWED = 'Group Transaction QR Code Viewed',

  // Group Quick Collect
  GROUP_QUICK_COLLECT_CLICKED = 'Group Quick Collect Clicked',
  GROUP_QUICK_COLLECT_SCREEN_VIEWED = 'Group Quick Collect Screen Viewed',
  GROUP_QUICK_COLLECT_ADD_FROM_LIST_CLICKED = 'Group Quick Collect Add From List Clicked',
  GROUP_QUICK_COLLECT_ADD_FROM_GROUP_LIST_CLICKED = 'Group Quick Collect Add From Group List Clicked',
  GROUP_QUICK_COLLECT_ADD_IMPORT_FILE_CLICKED = 'Group Quick Collect Add Import File Clicked',
  GROUP_QUICK_COLLECT_ADD_MANUALLY_CLICKED = 'Group Quick Collect Add Manually Clicked',
  GROUP_QUICK_COLLECT_ADD_MANUALLY_FORM_OPENED = 'Group Quick Collect Add Manually Form Opened',
  GROUP_QUICK_COLLECT_MEMBER_ADDED = 'Group Quick Collect Member Added',
  GROUP_QUICK_COLLECT_ADD_ANOTHER_CLICKED = 'Group Quick Collect Add Another Clicked',
  GROUP_QUICK_COLLECT_IMPORT_TEMPLATE_DOWNLOADED = 'Group Quick Collect Import Template Downloaded',
  GROUP_QUICK_COLLECT_IMPORT_FILE_UPLOADED = 'Group Quick Collect Import File Uploaded'
}

export type BusinessNameSampleFlow =
  | 'initial_onboarding'
  | 'kyc_via_banner'
  | 'branch_settings'
  | 'new_branch_modal'
  | 'upgrade_to_org';

export type KycDetailsFlowContext =
  | 'initial_onboarding'
  | 'kyc_via_banner'
  | 'upgrade_to_org'
  | 'resubmission';

export { Event, MixpanelEventV2 };

export const PageNames = {
  [AUTH.LOGIN]: 'Login',
  [PAGE_NOT_FOUND]: 'Page not found'
};
